import React, {Component} from 'react';
import SplashHeader from "./SplashHeader";
import '../../../css/splash.css'
import {ReactComponent as Thumb} from '../../../images/thumbs-up-black.svg'


class ResetPasswordCreated extends Component {

    render() {
        return (
            <div className="bac vh-100">
                <SplashHeader/>
                <div className="container  d-flex justify-content-around align-items-center pa3 mt-md-5 ">
                    <div className="box align-self-md-start  col-md-4  br4 border border-danger">
                        <div className="col-12 col-md-12 d-flex  ">
                            <div className=" thumb">
                                <Thumb/>
                            </div>
                        </div>

                        <div className="text-area">
                            <h1 className="submit-text">Reset link has been sent </h1>
                            <p className="p-text">Kindly check your mail for the password reset link.
                            </p>
                            <a href="/login">
                                <button className="next-button">Back to Log In</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default ResetPasswordCreated;
